import React, { useEffect, useState } from "react"
import { useAddManualAttendanceByCpdEventMutation, useGetFullNameByGMAPNumberMutation } from "../../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import SwalAlert from "../../../services/swalService/SwalService";
import FormInputFields from "../../../components/Forms/formField/FormInputFields";
import Buttons from "../../../components/ui/button/Buttons";

const AddManualAttendance = (props) => {
    const { error } = SwalAlert();
    const [AddManualAttendance, { isSuccess: isAddManualAttendanceFetched, isLoading: isAddManualAttendanceFetching, data: getAddManualAttendanceData },] = useAddManualAttendanceByCpdEventMutation();
    const [getFullNameByGMAPNumber, { isSuccess: isgetFullNameByGMAPNumberSuccess, isLoading: isLoadinggetFullNameByGMAPNumber, data: getFullNameByGMAPNumberData },] = useGetFullNameByGMAPNumberMutation();
    const [formValues, setFormValues] = useState({
        gmpNumber: '',
        gmpName: '',
    });
    const [formData, setFormData] = useState();

    useEffect(() => {
        if (!isLoadinggetFullNameByGMAPNumber && isgetFullNameByGMAPNumberSuccess && getFullNameByGMAPNumberData) {
            if (getFullNameByGMAPNumberData?.gmapMemberName === "Terminate Member, Please enter active Member!!") {
                error("Terminate Member, Please enter active GMP Number.");
                return;
            }
            if (getFullNameByGMAPNumberData?.gmapMemberName === "Name Not Found") {
                error("Record Not Found.");
                return;
            }
            setFormValues({
                ...formValues,
                gmpName: getFullNameByGMAPNumberData?.gmapMemberName || '',
            });

        }
    }, [isLoadinggetFullNameByGMAPNumber, isgetFullNameByGMAPNumberSuccess, getFullNameByGMAPNumberData]);

    const handlSearch = () => {
        if (!formValues.gmpNumber) {
            error("Please Enter GMP Number.");
            return;
        }
        resetFormforSearch();
        getFullNameByGMAPNumber({ GMAPNumber: formValues.gmpNumber || null, });
    }
    useEffect(() => {
        if (!isAddManualAttendanceFetching && isAddManualAttendanceFetched && getAddManualAttendanceData) {
            if (getAddManualAttendanceData?.errorMessage === "Already submitted Manual Attendance") {
                error("Already submitted Manual Attendance for this GMP Number.");
                return;
            }
            props.getdata(formData);
        }
    }, [isAddManualAttendanceFetching, isAddManualAttendanceFetched, getAddManualAttendanceData]);

    const handleSubmit = () => {
        const { gmpNumber, gmpName } = formValues;
        if (!gmpNumber || !gmpName) {
            error("Please fill all mandatory fields.", "")
            return;
        }
        else if (!props.eventId) {
            error("Please select cpd event.", "")
            return;
        }
        let request = {
            CpdEventId: props.eventId,
            GmpNumber: gmpNumber || null,
            GmpName: gmpName || null
        }
        AddManualAttendance(request);
        setFormData(request)
        resetForm();
    }

    const resetForm = () => {
        setFormValues({
            gmpNumber: '',
            gmpName: '',
        });
    }
    const resetFormforSearch = () => {
        setFormValues({
            gmpNumber: formValues.gmpNumber,
            gmpName: '',
        });
    }

    const handNameChange = (dataField, value) => {
        setFormValues({ ...formValues, [dataField]: value });
    }

    return (
        <div className="row">
            <form className="custom-attendance-form">
                <div class="form-group custom-form-group">
                    <div className="form-input">
                        <div class="inline-search mb-3">
                            <FormInputFields
                                labelName="GMP Number"
                                isRequired={true}
                                name="gmpNumber"
                                value={formValues.gmpNumber}
                                onChange={handNameChange}
                                dataField={"gmpNumber"}
                            />
                        </div>
                        <button class="btn success-btn mt-3" type="button" onClick={handlSearch}>Search</button>
                    </div>
                </div>
                <div class="form-group custom-form-group mb-3">
                    <div className="form-input full-width">
                        <div class="inline-search">
                            <FormInputFields
                                labelName="GMP Name"
                                name="gmpName"
                                value={formValues?.gmpName}
                                onChange={handNameChange}
                                dataField={"gmpName"}
                                isDisable={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex justify-content-center mt-3">
                    <Buttons
                        buttonText="Submit"
                        buttonTypeClassName="btn success-btn"
                        isLoading={isAddManualAttendanceFetching}
                        isDisable={isAddManualAttendanceFetching}
                        onClick={handleSubmit}
                    />
                </div>
            </form>
        </div>
    )
};

export default AddManualAttendance;
